<template>
  <transition name="fade">
    <button
      v-show="visible"
      v-tippy="{ placement: 'left', arrow: true }"
      type="button"
      class="vue-back-to-top"
      :content="label"
      :aria-label="label"
      @click="backToTop"
    >
      <i class="fas fa-chevron-up" aria-hidden="true" />
    </button>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: ''
    },
    visibleoffset: {
      type: [String, Number],
      default: 600
    },
    visibleoffsetbottom: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    label() {
      return this.text || this.$t('Components.shared.BackToTop.backToTop');
    }
  },
  mounted() {
    window.smoothscroll = () => {
      const currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.scrollTo(0, 0);
      }
    };
    window.addEventListener('scroll', this.watchScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.watchScroll);
  },
  methods: {
    watchScroll() {
      const pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset);
      const pastBottomOffset =
        window.innerHeight + window.pageYOffset >=
        document.body.offsetHeight - parseInt(this.visibleoffsetbottom);
      this.visible =
        parseInt(this.visibleoffsetbottom) > 0
          ? pastTopOffset && !pastBottomOffset
          : pastTopOffset;
    },
    backToTop() {
      window.smoothscroll();
    }
  }
};
</script>

<style lang="scss" scoped>
// Minimal back-to-top — chevron on a clean white circle, no
// brand fill or pill chrome. Sits fixed in the bottom-right;
// hovers tint the chevron in the brand colour.
.vue-back-to-top {
  position: fixed;
  right: 1.5rem;
  bottom: 4.5rem;
  z-index: 1000;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  background: #ffffff;
  color: #6b7280;
  font-size: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: color 0.15s, transform 0.15s, box-shadow 0.15s, border-color 0.15s;
  outline: none;

  &:hover,
  &:focus-visible {
    color: var(--color-primary, #047873);
    border-color: var(--color-primary, #047873);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.14), 0 2px 4px rgba(0, 0, 0, 0.06);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
